import * as bootstrap from 'bootstrap'
import * as _ from 'lodash-es'
import '@selectize/selectize/dist/js/selectize.js'
import '@selectize/selectize/dist/css/selectize.bootstrap5.css'
import bootbox from 'bootbox'
import Sortable from 'sortablejs'

var selectedIcon: string
var selectizeInstance
let searchTimeout

var categoryRuleset

const meta = 'categories'
window[`fnc_${meta}`] = initCategoriesPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

const all = _.uniq(_.flattenDeep(_.map(Object.values(globals.vars.icons), 'icons')))

function loadIcons() {
    let _arr = all

    if ($('#iconFilter').val() !== '') {
        const filter = $('#iconFilter').val() as string

        const regex = new RegExp(filter)

        _arr = _.filter(all, function(o) {
            return regex.test(o)
        })
    }

    $('#icon-selector-modal').find('.f-icons').html(_.map(_arr, function(o) {
        return `<i class="fas fa-${o} b ic fa-2x flex-fill m-1"></i>`
    }).join(''))

    $('.ic').on('mouseover', function(e) {
        $(this).addClass('text-primary')
    }).on('mouseleave', function(e) {
        $(this).removeClass('text-primary')
    }).on('click', function(e) {
        selectedIcon = $(this).attr('class').replace(/(fa.? fa.*) b .*/, '$1')

        $('#icon-selector-modal').find('[data-bs-dismiss="modal"]').trigger('click')
        
        const myModal2 = new bootstrap.Modal(document.getElementById('category-modal'), {})
        myModal2.show()

    })
}


function initCategoriesPage() {
    initRules()

     const el = document.getElementById('categories-list')

    new Sortable(el, {
        swap: true,
        animation: 150,
        handle: '.handle',
        dataIdAttr: 'data-category-id',
        ghostClass: "bg-light",  // Class name for the drop placeholder
	    chosenClass: "border-primary",  // Class name for the chosen item
        group: "categories",
        store: {
            get: function (sortable) {
                //var order = localStorage.getItem(sortable.options.group.name)
                //return order ? JSON.parse(order) : []
                return []
            },
    
            set: function (sortable) {
                 const params = {
                    ids: sortable.toArray(),
                    _csrf: $("meta[name=_csrf]").attr("content")
                }

                $.ajax({
                    url: '/json/category/sort',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (typeof response['error'] !== 'undefined') {
                            console.log(response);
                            alert(`Error: ${response['error']} (${response['code']})`)
                        }
            
                        if (DEBUG) console.log(response)           
                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            }
        },
        // onEnd: function (evt) {
        //     var itemEl = evt.item;  // dragged HTMLElement
        //    console.log( evt.to);    // target list
        //    console.log( evt.from);   // previous list
        //    console.log( evt.oldIndex);   // element's old index within old parent
        //    console.log( evt.newIndex);   // element's new index within new parent
        //    console.log( evt.oldDraggableIndex);  // element's old index within old parent, only counting draggable elements
        //    console.log( evt.newDraggableIndex);  // element's new index within new parent, only counting draggable elements
        //    console.log( evt.clone);  // the clone element
        //    console.log( evt.pullMode);  // when item is in another sortable: `"clone"` if cloning, `true` if moving
        // },
    })

    $('.sw-cat-stats').off().on('change', function(e) {
        e.preventDefault()
        
        const cat_id = $(this).closest('div[data-category-id]').attr('data-category-id')

        const params = {
            item: {
                _id: cat_id,
                statistics: $(this).prop('checked')
            }
        }

        if (DEBUG) console.log(params)

        helpers.updateCategory(params, false)

    })

    $('.sw-cat-reports').off().on('change', function(e) {
        e.preventDefault()
        
        const cat_id = $(this).closest('div[data-category-id]').attr('data-category-id')

        const params = {
            item: {
                _id: cat_id,
                reports: $(this).prop('checked')
            }
        }

        if (DEBUG) console.log(params)

        helpers.updateCategory(params, false)

    })



    $('#iconFilter').keyup(function(e) {
        clearTimeout(searchTimeout)
        searchTimeout = setTimeout(loadIcons, 200)
    })

    $('#icon-selector-modal').on('show.bs.modal', function() {
        $('#iconFilter').val('')

        loadIcons()
    })

    $('#icon-selector-modal').on('hide.bs.modal', function() {
        $('.ic').off()
    })

    $('#save-category-btn').off().on('click', function(e) {
        const t: string = $('#selectize-tags').val() as string
        const tags = _.compact(t.split('@|@'))

        const category = $('#categoryName').val()
        const stats = $('#evaluated').prop('checked')

        const reports = $('#reported').prop('checked')

        const params = {
            item: {
                _id: $('#categoryId').val(),
                name: category,
                icon: selectedIcon,
                tags: tags,
                statistics: stats,
                reports: reports
            }
        }

        if (DEBUG) console.log(params)

        $('button').prop('disabled', true)

        helpers.updateCategory(params, true)
    })

    $('#new-cat-lnk').off().on('click', function(e) {
        e.preventDefault()

        selectedIcon = 'fas fa-question-circle'

        $('#categoryId').val('')
        $('#categoryName').val('')
        $('#selectize-tags').val('')
        $('#evaluated').prop('checked', true)
        $('.del-category').addClass('visually-hidden')

        selectizeInstance.destroy() 
        const sel = $('#selectize-tags').off().selectize({
            persist: false,
            createOnBlur: true,
            create: true,
            showAddOptionOnCreate: true,
            delimiter: '@|@',
            render: {
                option_create: function(data, escape) {
                  return `<div class="create">${global.i18n.t('buttons.add')} <strong>${escape(data.input)}</strong>&hellip;</div>`
                }
            },
        })

        selectizeInstance = sel[0].selectize

        const myModal2 = new bootstrap.Modal(document.getElementById('category-modal'), {})
        myModal2.show()
    })

    $('div[data-category-id]').each(function(idx, obj) {
        $(this).off().on('dblclick', function(e) {
            e.preventDefault()

            const categoryId = $(this).attr('data-category-id')
            const categoryName = globals.vars.userData.categoriesById[categoryId]['name']
            const categoryTags = typeof globals.vars.userData.categoriesById[categoryId]['tags'] !== 'undefined' ? globals.vars.userData.categoriesById[categoryId]['tags'] : []
            selectedIcon = globals.vars.userData.categoriesById[categoryId]['icon']
            const categoryStats = globals.vars.userData.categoriesById[categoryId]['statistics']
            const categoryReports = globals.vars.userData.categoriesById[categoryId]['reports']

            $('#selectize-tags').val(categoryTags.join('@|@'))
    
            selectizeInstance.destroy() 
            const sel = $('#selectize-tags').off().selectize({
                persist: false,
                createOnBlur: true,
                create: true,
                showAddOptionOnCreate: true,
                delimiter: '@|@',
                render: {
                    option_create: function(data, escape) {
                      return `<div class="create">${global.i18n.t('buttons.add')} <strong>${escape(data.input)}</strong>&hellip;</div>`
                    }
                },
            })
    
            selectizeInstance = sel[0].selectize
    
            $('#categoryId').val(categoryId)
            $('#categoryName').val(categoryName)
            $('#evaluated').prop('checked', categoryStats)
            $('#reported').prop('checked', categoryReports)
            $('.del-category').removeClass('visually-hidden')
    
            const myModal2 = new bootstrap.Modal(document.getElementById('category-modal'), {})
            myModal2.show()
        })
    })

    $('.edit-category').off().on('click', function(e) {
        e.preventDefault()

        const categoryId = $(this).attr('data-category')
        const categoryName = globals.vars.userData.categoriesById[categoryId]['name']
        const categoryTags = typeof globals.vars.userData.categoriesById[categoryId]['tags'] !== 'undefined' ? globals.vars.userData.categoriesById[categoryId]['tags'] : []
        selectedIcon = globals.vars.userData.categoriesById[categoryId]['icon']
        const categoryStats = globals.vars.userData.categoriesById[categoryId]['statistics']
        const categoryReports = globals.vars.userData.categoriesById[categoryId]['reports']

        $('#selectize-tags').val(categoryTags.join('@|@'))

        selectizeInstance.destroy() 
        const sel = $('#selectize-tags').off().selectize({
            persist: false,
            createOnBlur: true,
            create: true,
            showAddOptionOnCreate: true,
            delimiter: '@|@',
            render: {
                option_create: function(data, escape) {
                  return `<div class="create">${global.i18n.t('buttons.add')} <strong>${escape(data.input)}</strong>&hellip;</div>`
                }
            },
        })

        selectizeInstance = sel[0].selectize

        $('#categoryId').val(categoryId)
        $('#categoryName').val(categoryName)
        $('#evaluated').prop('checked', categoryStats)
        $('#reported').prop('checked', categoryReports)
        $('.del-category').removeClass('visually-hidden')

        const myModal2 = new bootstrap.Modal(document.getElementById('category-modal'), {})
        myModal2.show()
    })

    $('.del-category').off().on('click', function(e) {
        e.preventDefault()

        bootbox.confirm({
            title: global.i18n.t('dialogs.confirmation'),
            message: global.i18n.t('dialogs.generic_action'),
            centerVertical: true,
            buttons: {
                confirm: {
                label:  global.i18n.t('buttons.yes'),
                className: 'btn-danger'
                },
                cancel: {
                    label: global.i18n.t('buttons.no'),
                    className: 'btn-light'
                }
            },
            callback: function (result) {
                if (!result)
                    return

                const params = {
                    item: { _id: $('#categoryId').val() },
                    _csrf: $("meta[name=_csrf]").attr("content")
                }
                $.ajax({
                    url: '/json/category/delete',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (typeof response['error'] !== 'undefined') {
                            helpers.alert(response)
                        }
            
                        if (DEBUG) console.log(response)
            
                        window.location.reload()
                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            }
        })
    })

    $('#category-modal').on('show.bs.modal', function() {
        $('#icon').html(`<i class="${selectedIcon} fa-5x text-muted"></i>`)

        // return
        // if (typeof editedCategory !== 'undefined' && !_.isEmpty(editedCategory)) {


        // } else {
        //     $('#icon').html(`<i class="${selectedIcon} fa-5x text-muted"></i>`)
        //     $('#categoryId').val('')
        //     $('#categoryName').val('')
        //     selectizeInstance[0].selectize.setValue('')
        //     $('#evaluated').prop('checked', true)
        // }
    })


    const sel = $('#selectize-tags').selectize({
        persist: false,
        createOnBlur: true,
        create: true,
        showAddOptionOnCreate: true,
        delimiter: '@|@',
        render: {
            option_create: function(data, escape) {
              return `<div class="create">${global.i18n.t('buttons.add')} <strong>${escape(data.input)}</strong>&hellip;</div>`
            }
        },
    })

    selectizeInstance = sel[0].selectize

    $('[data-bs-toggle="collapse"]').off().on('click', function(e) {-
        $(this).closest('.modal-dialog').toggleClass('modal-xl')
        $(this).find('i').toggleClass('mdi-chevron-up')
    })
}


function booleanizeObject(obj) {
    var keys = Object.keys(obj)

    keys.forEach(function(key) {
        var value = obj[key]
       
        if (/^BSON\:/.test(value)) {
            console.log('OUIIII', value);
            obj[key] = obj[key].replace(/^BSON\:(.*)/, '$1'+new Date().toISOString())
        }

        if (typeof value === 'string') {
            var lvalue = value.toLowerCase()

            if (lvalue === 'true') {
                obj[key] = true;
            } else if (lvalue === 'false') {
                obj[key] = false;
            }
        } else if (typeof value === 'object') {
            booleanizeObject(obj[key]);
        }
    })

    return obj
}
  


function initRules(data?: object) {
    $('#test-btn').off().on('click', function(e) {
        //const result = $('#rules-builder').queryBuilder('getRules');
  
        const result = $('#rules-builder').queryBuilder('getMongo')

        const tt = booleanizeObject(result)

        console.log(JSON.stringify(tt, null, 2));
        //alert(JSON.stringify(tt, null, 2))

    })




    const accounts = _.map(_.orderBy(globals.vars.userData.accounts, ['custom_name', 'name'], ['asc', 'asc']), function(o) {
        const opt = {}
        
        if (o['archived'] === false)
            opt[o['_id']] = (o['custom_name'] !== '' ? o['custom_name'] : o['name']) || ''

        return opt
    })

    var rules_basic = {
        condition: 'AND',
        rules: [{
          id: 'price',
          operator: 'less',
          value: 10.25,
        }, {
          condition: 'OR',
          rules: [{
            id: 'category',
            operator: 'equal',
            value: 2
          }, {
            id: 'category',
            operator: 'equal',
            value: 1
          }]
        }]
      };
      
    categoryRuleset = $('#rules-builder').queryBuilder({
        lang_code: globals.vars.locales,
        plugins: {
            'bt-tooltip-errors': { delay: 100 },
            'sortable': { icon: 'fas fa-grip-vertical'},
            'unique-filter': null,
            'invert': null,
            //'not-group': { icon_checked: 'mdi mdi-checkbox-marked fw-bold text-danger', icon_unchecked: 'mdi mdi-checkbox-blank-outline fw-bold text-dark'},
        },       
        filters: [
            {
                id: 'account._id',
                label: global.i18n.t('categories.filters.account'),
                type: 'string',
                input: 'select',
                values: accounts,
                operators: ['equal']
            },
            {
                id: 'account.iban',
                label: global.i18n.t('categories.filters.iban'),
                type: 'string',

            },
            {
                id: 'account.account_type',
                label: global.i18n.t('categories.filters.account_type'),
                type: 'string',

            },
            {
                id: 'transactionAmount.currency',
                label: global.i18n.t('categories.filters.currency'),
                type: 'string',
                input: 'select',
                values: globals.vars.currencies,
                operators: ['equal']

            },
            {
                id: 'account.isOnline',
                label: global.i18n.t('categories.filters.isOnline'),
                type: 'boolean',
                input: 'radio',
                values: {
                    1: global.i18n.t('categories.filters.yes'),
                    0: global.i18n.t('categories.filters.no')
                },
                operators: ['equal']
            },
            {
                id: 'account.favorite',
                label: global.i18n.t('categories.filters.favorite'),
                type: 'boolean',
                input: 'radio',
                values: {
                    1: global.i18n.t('categories.filters.yes'),
                    0: global.i18n.t('categories.filters.no')
                },
                operators: ['equal']
            },
            {
                id: 'account.payment_account',
                label: global.i18n.t('categories.filters.payment_account'),
                type: 'boolean',
                input: 'radio',
                values: {
                    1: global.i18n.t('categories.filters.yes'),
                    0: global.i18n.t('categories.filters.no')
                },
                operators: ['equal']
            },                     
            {
                id: 'title',
                label: global.i18n.t('categories.filters.title'),
                type: 'string',

            },
            {
                id: 'receiver',
                label: global.i18n.t('categories.filters.receiver'),
                type: 'string',

            },
            {
                id: 'comment',
                label: global.i18n.t('categories.filters.comment'),
                type: 'string',

            },
            {
                id: 'amount', // not transactionAmount.amound - toDouble convert done on backend
                label: global.i18n.t('categories.filters.amount'),
                type: 'double',
                validation: {
                    step: 0.01
                }
            },
            {
                id: 'pending',
                label: global.i18n.t('categories.filters.pending'),
                type: 'boolean',
                input: 'radio',
                values: {
                    1: global.i18n.t('categories.filters.yes'),
                    0: global.i18n.t('categories.filters.no')
                },
                operators: ['equal']
            },
            {
                id: 'paid',
                label: global.i18n.t('categories.filters.paid'),
                type: 'boolean',
                input: 'radio',
                values: {
                    1: global.i18n.t('categories.filters.yes'),
                    0: global.i18n.t('categories.filters.no')
                },
                operators: ['equal']
            },

        // {
        //   id: 'id',
        //   label: 'Identifier',
        //   type: 'string',
        //   placeholder: '____-____-____',
        //   operators: ['equal', 'not_equal'],
        //   validation: {
        //     format: /^.{4}-.{4}-.{4}$/
        //   }
        // }
    ],
      
        //rules: []rules_basic
      }

    )
    // .on('validationError.queryBuilder.filter', function(e, level, value) {
    //     console.log(e);
    //     console.log(level);
    //     console.log(value);

    // })
    // .on('rulesChanged.queryBuilder.filter', function(e, level, value) {
    //     console.log(e);
    //     console.log(level);
    //     console.log(value);

    // })
    .on('getMongoDBField.queryBuilder.filter', function(e, field) {
        if (field.id == 'account._id')
            field.value = ['BSON:'+field.value]

    })
}
